import React from 'react';

import LinkMore from '@app/components/LocalCommon/LinkMore/LinkMore';
import { BOOKING } from '@app/components/LocalCommon/Utils/booking';
import CustomAvatar from '@app/components/UI/CustomAvatar/CustomAvatar';

const AreaPreview = (props) => {
	const { area, currentAreaUrl } = props;
	const avatarHeight = 360;
	const avatarWidth = 360;

	return (
		<>
			<div className="area-page__avatar">
				<CustomAvatar
					src={area.avatar}
					maxWidth={avatarWidth}
					maxHeight={avatarHeight}
				/>
			</div>
			<header className="area-page__header header-area">
				<h4 className="header-area__title">{area.name}</h4>
				<p className="header-area__caption">Contact information</p>
				<p className="header-area__phones">
					<a className="header-area__phone" href={`tel:${area.phoneNumber}`}>
						<span>{area.phoneNumber}</span>
					</a>
					<a className="header-area__phone" href={`tel:${area.secondPhoneNumber}`}>
						<span>{area.secondPhoneNumber}</span>
					</a>
				</p>
				<a className="header-area__email" href={`mailto: ${area.email}`}>
					{area.email}
				</a>
				<LinkMore
					linkMoreCaption="Schedule Appointment"
					linkMoreLink={area?.onlineBookingEnabled ? BOOKING : `${currentAreaUrl}/request-info`}
				/>
			</header>
		</>
	);
};

export default AreaPreview;
